import { isNumber } from "./isNumber";
export const operate = (operand0, operand1, operator) => {
    const num0 = parseFloat(operand0 || "0");
    const num1 = parseFloat(operand1 || (operator === "/" || operator === "*" ? "1" : "0"));
    switch (operator) {
        case "+": {
            return num0 + num1;
        }
        case "-": {
            return num0 - num1;
        }
        case "*": {
            return num0 * num1;
        }
        case "/": {
            if (operand1 === "0") {
                alert("Invalid 0 division.");
                return 0;
            }
            else {
                return num0 / num1;
            }
        }
        case "%": {
            return num0 % num1;
        }
        default: {
            throw Error(`Unknown operator '${operator}'`);
        }
    }
};
export const handleAction = (calculatorState, key) => {
    if (key === "AC")
        return {
            currOperand: undefined,
            operator: undefined,
            prevOperand: undefined,
        };
    if (key === "DEL")
        return Object.assign(Object.assign({}, calculatorState), { currOperand: calculatorState.currOperand
                ? calculatorState.currOperand.slice(0, -1)
                : undefined });
    if (key === "=" && calculatorState.operator) {
        console.log(calculatorState);
        const operationResult = operate(calculatorState.prevOperand, calculatorState.currOperand, calculatorState.operator).toString();
        return {
            currOperand: operationResult,
            operator: undefined,
            prevOperand: undefined,
        };
    }
    if (isNumber(key)) {
        return Object.assign(Object.assign({}, calculatorState), { currOperand: calculatorState.currOperand === "0"
                ? key
                : (calculatorState.currOperand || "") + key });
    }
    if (calculatorState.currOperand || calculatorState.prevOperand) {
        if (!calculatorState.operator) {
            return {
                operator: key,
                currOperand: undefined,
                prevOperand: calculatorState.currOperand,
            };
        }
        else {
            return Object.assign(Object.assign({}, calculatorState), { operator: key });
        }
    }
    else {
        return calculatorState;
    }
};
